var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDateDifference = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M10.667 13.292a.4.4 0 0 1-.4.4h-.534a.4.4 0 0 1 0-.8h.534a.4.4 0 0 1 .4.4m3.6.4a.4.4 0 0 0 0-.8h-.534a.4.4 0 0 0 0 .8zM12 11.958a.4.4 0 0 1-.4-.4v-.533a.4.4 0 0 1 .8 0v.533a.4.4 0 0 1-.4.4m-.4 3.6a.4.4 0 0 0 .8 0v-.533a.4.4 0 0 0-.8 0zm1.343-3.209a.4.4 0 0 1 0-.566l.377-.377a.4.4 0 1 1 .566.566l-.377.377a.4.4 0 0 1-.566 0m-2.829 2.263a.4.4 0 1 0 .566.565l.377-.377a.4.4 0 0 0-.566-.566zm.943-2.263a.4.4 0 0 0 0-.566l-.377-.377a.4.4 0 0 0-.566.566l.377.377a.4.4 0 0 0 .566 0m2.829 2.263a.4.4 0 0 1-.566.565l-.377-.377a.4.4 0 0 1 .566-.566z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M8.6 5.625c.22 0 .4.18.4.4v.933h5.667v-.933a.4.4 0 0 1 .8 0v.933H16.5a1.5 1.5 0 0 1 1.5 1.5v1.167h-.005a1 1 0 0 1 .005.083v6.417a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5V9.708q0-.042.005-.083H6V8.458a1.5 1.5 0 0 1 1.5-1.5h.7v-.933c0-.22.18-.4.4-.4m-1.7 10.5V9.858h10.2v6.267a.6.6 0 0 1-.6.6h-9a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDateDifference);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/date-difference.06169f74.svg";